module.exports = __webpack_public_path__ + "img/img_smart_img2.324399f8.png";